import axios, { AxiosError } from 'axios';
import { User } from '../interfaces/User';
import { useSettingsStore } from '../store/settingsStore';


const api = () => axios.create({
    baseURL: useSettingsStore.getState().apiUrl || import.meta.env.VITE_MAIN_API_URL,
    withCredentials: true,
});



export interface LoginCredentials {
    email: string;
    password: string;
}

export interface RegisterCredentials {
    email: string;
    password: string;
    invitation_code?:string;
}

export const login = async (credentials: LoginCredentials): Promise<User> => {
    try {
        const response = await api().post<{ user: User }>('/auth/login', credentials,{withCredentials: true});
        return response.data.user;
    } catch (error) {
        throw handleApiError(error, 'Login failed');
    }
};

export const register = async (credentials: RegisterCredentials): Promise<User> => {
    try {
        //console.log("sending credentials",credentials)
        const response = await api().post<{ user: User }>('/auth/register', credentials,{withCredentials: true});
        return response.data.user;
    } catch (error) {
        throw handleApiError(error, 'Registration failed');
    }
};

export const logout = async (): Promise<void> => {
    try {
        await api().post('/auth/logout',{},{withCredentials: true});
    } catch (error) {
        handleApiError(error, 'Logout failed');
    }
};


export const runVideoAnalysis = async (params:any): Promise<any> => {
    try {
        let response:any;
        const analyzeWorkflowName = useSettingsStore.getState().analyzeWorkflowName;
        if (params.file) {
            const formData = new FormData();
            formData.append('file', params.file);
            console.log("sending file");
            response = await api().post('/workflows/'+analyzeWorkflowName,formData,{withCredentials: true , headers: {'Content-Type': 'multipart/form-data' }});
        } else {
            response = await api().post('/workflows/'+analyzeWorkflowName,params,{withCredentials: true });
        }
        return response?.data || {};
        //console.log("task",task)
    } catch (error) {
        handleApiError(error, 'Video Analysis failed');
    }
};

export const runShorten = async (params:any): Promise<any> => {
    try {
        let response:any;
        const workflowName = useSettingsStore.getState().shortenWorkflowName;
        response = await api().post('/workflows/'+workflowName,params,{withCredentials: true });
        return response?.data || {};
        //console.log("task",task)
    } catch (error) {
        handleApiError(error, 'Video Analysis failed');
    }
};

export const runFixShorten = async (params:any): Promise<any> => {
    try {
        let response:any;
        const workflowName = useSettingsStore.getState().fixingWorkflowName;
        response = await api().post('/workflows/'+workflowName,params,{withCredentials: true });
        return response?.data || {};
        //console.log("task",task)
    } catch (error) {
        handleApiError(error, 'Video Analysis failed');
    }
};

export const getVideoAnalysis = async (job_id:string): Promise<any> => {
    try {
        const response = await api().get(`/workflows/jobs/${job_id}`,{withCredentials: true});
        return response?.data || {};
        //console.log("task",task)
    } catch (error) {
        handleApiError(error, 'Video Analysis result failed');
    }
};

export const cancelVideoAnalysis = async (job_id:string): Promise<any> => {
    try {
        const response = await api().delete(`/workflows/jobs/${job_id}`,{withCredentials: true});
        return response?.data || {};
        //console.log("task",task)
    } catch (error) {
        handleApiError(error, "Error canceling task");
    }
};

export const getVideoAnalysisDebugInfo = async (job_id:string): Promise<any> => {
    try {
        const response = await api().get(`/admin/jobs/${job_id}/debug`,{withCredentials: true});
        return response?.data || {};
        //console.log("task",task)
    } catch (error) {
        handleApiError(error, 'Video Analysis result failed');
    }
};

export const getCurrentUser = async (): Promise<User> => {
    try {
        const url = useSettingsStore.getState().apiUrl || import.meta.env.VITE_MAIN_API_URL;
        console.log("Calling /auth/me on:", url);
        const response = await api().get<{ user: User }>('/auth/me',{withCredentials: true});
        return response.data.user;
    } catch (error) {
        throw handleApiError(error, 'Failed to get current user');
    }
};

export const fetchData = async (model:string,querydata:string) => {
    try {
        const response = await api().get(`/${model}?${querydata}`,{withCredentials: true});
        return response?.data || {};
    } catch (error) {
        throw handleApiError(error, 'Failed to fetch' + model);
    }
};

export const save = async (model:string, id:string, obj:any) => {
    try {
        const response = await api().put(`/${model}/${id}`,obj,{withCredentials: true});
        return response?.data || {};
    } catch (error) {
        throw handleApiError(error, 'Failed to save' + model);
    }
};

export const add = async (model:string, obj:any) => {
    try {
        const response = await api().post(`/${model}`,obj,{withCredentials: true});
        return response?.data || {};
    } catch (error) {
        throw handleApiError(error, 'Failed to add ' + model);
    }
};

export const deleteItem = async (model:string, id:string) => {
    try {
        const response = await api().delete(`/${model}/${id}`,{withCredentials: true});
        return response?.data || {};
    } catch (error) {
        throw handleApiError(error, 'Failed to delete' + model);
    }
};


export const jsonToAaf = async (params: any): Promise<Blob | undefined> => {
    try {
      const response = await api().post('/utils/generate-aaf', params, {
        responseType: 'blob',
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      handleApiError(error, 'AAF generation failed');
    }
  };

const handleApiError = (error: any, defaultMessage: string): never => {
    if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<{ message: string }>;
        if (axiosError.response?.data?.message) {
            //console.error('API Error:', axiosError.response.data.message);
            throw new Error(axiosError.response.data.message);
        }
    }
    console.log("ehnn",error.response)
    let display_err=error?.response?.data || error?.error || error?.message || defaultMessage;
    if (typeof display_err !== 'string') display_err=JSON.stringify(display_err);
    throw new Error(display_err);
};